import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles/index';
import ContinueButton from '../../../common/components/Buttons/ContinueButton';
import colors from '../../../../config/themeColors';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: 'calc(100% - 32px)',
        marginLeft: '16px',
        marginRight: '16px',
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    image: {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: colors.white2,
        margin: '32px auto',
    },
    congratulation: {
        fontSize: '32px',
        lineHeight: 1.1,
        color: colors.black,
    },
    congratulationDesc: {
        fontSize: '22px',
        lineHeight: 1.1,
        color: colors.black,
        marginBottom: '16px',
    },
    checkboxes: {
        marginTop: '24px',
        marginBottom: '24px',
    },
    checkbox: {
        height: '32px',
    },
    text: {
        color: colors.brownishGrey,
    },
    textCenter: {
        textAlign: 'center',
    },
});

function RequestUnderWritting(props) {
    return (
        <div className={props.classes.root}>
            <div className={props.classes.textCenter}>
                <div className={props.classes.image}>
                    &nbsp;
                </div>
                <Typography className={props.classes.congratulation}>
                    Please check
                </Typography>
                <Typography className={props.classes.congratulationDesc}>
                    Underwriting Summary
                </Typography>
                <Typography className={props.classes.text}>
                    Make sure all data in the next column is correct. <br/>
                    After clicking „Accept & Check” button you will not be able to return.
                </Typography>
            </div>
            <div className={props.classes.checkboxes}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={props.acceptedHardCheck}
                                className={props.classes.checkbox}
                                onChange={() => props.setAcceptedHardCheck(!props.acceptedHardCheck)}
                                value="true"
                            />
                        }
                        classes={{ label: props.classes.text }}
                        label="I authorise SGL Fintech to perform a Hard Credit Check"
                    />
                </FormGroup>
            </div>
            <Typography className={props.classes.text}>
                By clicking „Accept & Check” you agree to SGL Fintech conducting a hard credit check,
                also known as a Quotation search on your profile.
                This will adversely affect your credit score and will
                not be available for other lenders to see, only you.
                If you would like more information on this please click here.
            </Typography>

            <div className={props.classes.buttons}>
                <Button
                    className={props.classes.button}
                    color="default"
                    onClick={() => {
                        props.setStep(8);
                        props.setStepCompleted(9, false);
                    }}
                >
                    Back
                </Button>
                <ContinueButton
                    className={props.classes.button}
                    onClick={() => {
                        props.setStepCompleted(9, true);
                        props.doHardCheck();
                    }}
                >
                    Accept &amp; Check
                </ContinueButton>
            </div>
        </div>
    );
}

RequestUnderWritting.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    acceptedHardCheck: PropTypes.bool.isRequired,
    setAcceptedHardCheck: PropTypes.func.isRequired,
    doHardCheck: PropTypes.func.isRequired,
};

export default withStyles(styles)(RequestUnderWritting);



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/components/RequestUnderWritting.js